interface CustomerInfoProps {
  info?: {
    name: string;
    phone: string;
    email: string;
  };
  setInfo: (info: { name: string; phone: string; email: string }) => void;
}

export default function CustomerInfo({ info: infoProp, setInfo }: CustomerInfoProps) {
  const info = infoProp ?? { name: '', phone: '', email: '' };

  const handleChange = (field: string, value: string) => {
    setInfo({ ...info, [field]: value });
  };

  const formatPhone = (value: string) => {
    const numbers = value.replace(/[^\d]/g, '');
    if (numbers.length <= 3) return numbers;
    if (numbers.length <= 7) return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}`;
  };

  const handlePhoneChange = (value: string) => {
    const formatted = formatPhone(value);
    handleChange('phone', formatted);
  };

  const isValidEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  return (
    <div>
      <div className="text-center mb-10">
        <h2 className="font-serif text-3xl font-light text-[#2D2D2D] mb-4">
          고객 정보를 입력해주세요
        </h2>
        <p className="text-gray-500 text-sm font-light leading-relaxed">
          결과물 전달 및 문의 응대를 위해 정확한 정보를 입력해주세요.
        </p>
      </div>

      <div className="bg-white rounded-2xl p-8 border border-gray-200 space-y-6">
        {/* Name */}
        <div>
          <label className="block text-sm font-medium text-[#2D2D2D] mb-3">
            성함 <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={info.name}
            onChange={(e) => handleChange('name', e.target.value)}
            placeholder="홍길동"
            className="w-full px-5 py-3.5 border border-gray-300 rounded-xl text-base focus:outline-none focus:border-[#C9A96E] focus:ring-2 focus:ring-[#C9A96E]/20 transition-all duration-200"
          />
        </div>

        {/* Phone */}
        <div>
          <label className="block text-sm font-medium text-[#2D2D2D] mb-3">
            연락처 <span className="text-red-500">*</span>
          </label>
          <input
            type="tel"
            value={info.phone}
            onChange={(e) => handlePhoneChange(e.target.value)}
            placeholder="010-1234-5678"
            maxLength={13}
            className="w-full px-5 py-3.5 border border-gray-300 rounded-xl text-base focus:outline-none focus:border-[#C9A96E] focus:ring-2 focus:ring-[#C9A96E]/20 transition-all duration-200"
          />
          <p className="mt-2 text-xs text-gray-500 flex items-center gap-1">
            <i className="ri-notification-3-line"></i>
            제작 완료 시 이 연락처로 알림이 발송됩니다.
          </p>
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-[#2D2D2D] mb-3">
            이메일 <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            value={info.email}
            onChange={(e) => handleChange('email', e.target.value)}
            placeholder="example@email.com"
            className="w-full px-5 py-3.5 border border-gray-300 rounded-xl text-base focus:outline-none focus:border-[#C9A96E] focus:ring-2 focus:ring-[#C9A96E]/20 transition-all duration-200"
          />
          {info.email && !isValidEmail(info.email) && (
            <p className="mt-2 text-xs text-red-500">
              올바른 이메일 형식을 입력해주세요
            </p>
          )}
        </div>
      </div>

      {/* Privacy Notice */}
      <div className="mt-8 bg-[#FDF5EA] rounded-xl p-6">
        <div className="flex items-start gap-3">
          <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#C9A96E] shrink-0 mt-0.5">
            <i className="ri-shield-check-line text-sm text-white"></i>
          </div>
          <div>
            <p className="text-sm font-medium text-[#2D2D2D] mb-2">
              개인정보 보호
            </p>
            <p className="text-xs text-gray-600 font-light leading-relaxed">
              입력하신 정보는 서비스 제공 목적으로만 사용되며, 결과물 전달 후 안전하게 삭제됩니다. 
              업로드하신 사진은 AI 생성 완료 후 삭제되어 외부 유출 걱정이 없습니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}